import ContactMethodRow from './ContactMethodRow';

export default ContactMethodRow;
